document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]')
  const menuToggle = document.querySelectorAll('[data-header-menu-toggle]')

  menuToggle.forEach((item) => {
    item.addEventListener('click', () => {
      document
        .querySelector('[data-layout-wrapper]')
        .classList.toggle('is-layout-locked')
      header.classList.toggle('is-menu-active')
    })
  })

  const searchInput = document.querySelector('[data-header-search-field]')
  const searchGroupLogo = document.querySelector(
    '[data-header-search-group-logo]',
  )
  const searchButton = document.querySelector('[data-header-search-toggle]')

  searchButton?.addEventListener('click', () => {
    searchInput.classList.toggle('is-hidden')
    searchGroupLogo.classList.toggle('is-hidden')
    searchInput.querySelector('input').focus()
    searchButton
      .querySelectorAll('[data-header-search-icon]')
      .forEach((item) => item.classList.toggle('is-hidden'))
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const clears = document.querySelectorAll('[data-input-field-clear]')
  clears.forEach((item) => {
    const input = item.closest('[data-input-field]').querySelector('input')
    input.addEventListener('input', (e) => {
      if (e.target.value) {
        if (!item.classList.contains('is-visible')) {
          item.classList.add('is-visible')
        }
      } else {
        item.classList.remove('is-visible')
      }
    })
    item.addEventListener('click', () => {
      item.classList.remove('is-visible')
      input.value = ''
      input.focus()
    })
  })
})
